module.exports = __webpack_public_path__ + "img/banner4.0c05f598.png";